"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/empty/style/index.js
// module id = 330
// module chunks = 1